import React from "react";


function Template(props) {
    return (
        <row>
            <br />
            <div className="col-12 text-center">
                <h1>404 Page Not Found</h1>
                <h2>Sorry, this page doesn't exist</h2>
            </div>  
        </row>
    );
}

export default Template;